import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M13.13 23.28a10.15 10.15 0 1 1 10.15-10.16 10.17 10.17 0 0 1-10.15 10.16zm0-19A8.85 8.85 0 1 0 22 13.12a8.87 8.87 0 0 0-8.87-8.85z' }),
  React.createElement('path', { d: 'M19.48 13.12h-1.31a5.05 5.05 0 0 0-5-5V6.77a6.36 6.36 0 0 1 6.31 6.35z' }),
  React.createElement('path', {
    transform: 'rotate(-45 25.50122292 25.4970476)',
    d: 'M24.85 21.43h1.3v8.13h-1.3z'
  })
));